export enum AcceptanceCriteriaStatus {
    NotReviewed = 0,
    ReviewedNotNeeded = 1,
    ReviewedEnabled = 2,
    ReviewedManualNeeded = 3,
    ReviewedDisableAutomatch = 4,
    ReviewedAlwaysRequireNew = 5
}

export namespace AcceptanceCriteriaStatus {
    export function toString(): string;
    export function toString(level: AcceptanceCriteriaStatus): string;
    export function toString(level?: AcceptanceCriteriaStatus): string {
        return level !== null
            ? AcceptanceCriteriaStatus[level]
            : Object.prototype.toString.call(AcceptanceCriteriaStatus);
    }

    export function toName(enumValue: AcceptanceCriteriaStatus): string {
        switch (enumValue) {
            case AcceptanceCriteriaStatus.NotReviewed:
                return 'Not Reviewed';
            case AcceptanceCriteriaStatus.ReviewedNotNeeded:
                return 'Reviewed - No Acceptance Criteria Needed at this Level';
            case AcceptanceCriteriaStatus.ReviewedEnabled:
                return 'Reviewed - Enable Acceptance Criteria';
            case AcceptanceCriteriaStatus.ReviewedManualNeeded:
                return 'Reviewed - Manual Review Needed';
            case AcceptanceCriteriaStatus.ReviewedDisableAutomatch:
                return 'Reviewed - Disable Automatch';
            case AcceptanceCriteriaStatus.ReviewedAlwaysRequireNew:
                return 'Reviewed - Always Require New Document';
        }
    }

    export function fromName(name: string): AcceptanceCriteriaStatus | undefined {
        switch (name) {
            case 'Not Reviewed':
                return AcceptanceCriteriaStatus.NotReviewed;
            case 'Reviewed - No Acceptance Criteria Needed at this Level':
                return AcceptanceCriteriaStatus.ReviewedNotNeeded;
            case 'Reviewed - Enable Acceptance Criteria':
                return AcceptanceCriteriaStatus.ReviewedEnabled;
            case 'Reviewed - Manual Review Needed':
                return AcceptanceCriteriaStatus.ReviewedManualNeeded;
            case 'Reviewed - Disable Automatch':
                return AcceptanceCriteriaStatus.ReviewedDisableAutomatch;
            case 'Reviewed - Always Require New Document':
                return AcceptanceCriteriaStatus.ReviewedAlwaysRequireNew;
            default:
                return undefined;
        }
    }
}
